<template>
  <div>
    <div class="rig">
      <div class="spin">
        <div class="lds-hourglass"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {};
</script>

<style lang="scss" scoped>
.rig{
  position: absolute;
  left: 0;
  top: 0;
  margin: 0 auto;
  z-index: 1000;
}
.spin{
  z-index: -10;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.2);
  position: fixed;
}
.lds-hourglass {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: calc(50% - 40px);
  left: calc(50% - 40px);
}
.lds-hourglass:after {
  content: " ";
  display: block;
  border-radius: 50%;
  width: 0;
  height: 0;
  margin: 8px;
  box-sizing: border-box;
  border: 32px solid #fff;
  border-color: red transparent red transparent;
  animation: lds-hourglass 1.2s infinite;
}
@keyframes lds-hourglass {
  0% {
    transform: rotate(0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  50% {
    transform: rotate(900deg);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  100% {
    transform: rotate(1800deg);
  }
}
</style>
